// @flow

import styled from "styled-components";

import spacingExtender from "./spacingExtender";
import { fullColorExtender } from "./colors";

const Text = styled.div`
  ${({ type, size, margin, theme, lineHeight }) => {
  const fontFamily = theme.fonts.family[`${type}Text`];
  const fontSize = theme.fonts.sizes[`Text${size}`];
  const fontWeight = theme.fonts.weight[`${type}Text`];

  let styles = {};
  if (fontFamily) {
    styles.fontFamily = fontFamily;
  }

  if (fontSize) {
    styles.fontSize = fontSize;
  }
  if (fontWeight) {
    styles.fontWeight = fontWeight;
  }

  if (lineHeight) {
    styles.lineHeight = lineHeight;
  }

  return styles;
}}
  ${spacingExtender};
  ${fullColorExtender};
`;

export default Text;



// WEBPACK FOOTER //
// ./src/common/text.js